// extracted by mini-css-extract-plugin
module.exports = {"info":"cd01fbf7b5--info--FKnj4","company-link":"cd01fbf7b5--company-link--TbAEm"};